import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageHeaderPayment from "./pajeheader";
import stripelogo from "../../../assets/svg/stripe.svg";
import paypallogo from "../../../assets/svg/paypal.svg";
import bitpaylogo from "../../../assets/svg/bitpay.svg";
import paystacklogo from "../../../assets/svg/paystack.svg";
import phonepelogo from "../../../assets/svg/phonepe.svg";
import pesalogo from "../../../assets/svg/pesa.svg";
import Stripeaccount from "./Stripeaccount";
import ConfirmationModal from "../../../components/common/ConfirmationModal/ConfirmationModal";

export default function PaymentIntegrationoptions() {
  const [open, setOpen] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [apikey, setApikey] = useState("");
  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
  });

  const handleOpen = (data) => {
    setOpen(true);
    setPhoto(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getKey = localStorage.getItem("apiKey");

  const deleteHandler = () => {
    console.log("Disconnect confirmed");
    setConfirmationModalState({ showModal: false });
  };

  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false });
  };

  const handleDisconnectClick = (row) => {
    setConfirmationModalState({ showModal: true });
    localStorage.removeItem("apiKey");
    setApikey("");
  };

  const paymentData = [
    { logo: stripelogo, text: "Stripe" },
    { logo: paypallogo, text: "PayPal" },
    { logo: bitpaylogo, text: "BitPay" },
    { logo: paystacklogo, text: "PayStack" },
    { logo: phonepelogo, text: "PhonePe" },
    { logo: pesalogo, text: "Mpesa" },
  ];
  useEffect(() => {
    if (getKey) {
      setApikey(getKey);
    }
  }, [getKey]);

  return (
    <Box mt={3}>
      {paymentData.map((row, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #E0E0E0",
            borderRadius: "7px",
            padding: { xs: "8px 16px", sm: "10px 20px" },
            // maxWidth: { xs: "100%", sm: "100%", md: "1111px" },
            marginBottom: "10px",
          }}
        >
          {/* Left section - Service Logo */}
          <Box sx={{}}>
            <img
              src={row.logo}
              alt="logo"
              width={row.logo === stripelogo ? "60px" : "84px"}
              height={"30.76px"}
            />
          </Box>

          {/* Right section - Obfuscated Text and Button */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {apikey && row.text === "Stripe" ? (
              <Typography
                sx={{ fontWeight: 400, fontSize: "14px" }}
              >{`xxxx-xxxx-xxxx-${apikey.slice(-4)}`}</Typography>
            ) : null}

            {/* Disconnect Button */}
            {apikey && row.text === "Stripe" ? (
              <Button
                variant="outlined"
                sx={{
                  color: "#5F5FEF",
                  borderColor: "#E0E0E0",
                  borderRadius: "6px",
                  fontSize: { xs: "12px", sm: "14px" },
                  padding: { xs: "4px 10px", sm: "6px 15px" },
                  height: "40px",
                  width: "106px",
                }}
                onClick={() => handleDisconnectClick(row)}
              >
                Disconnect
              </Button>
            ) : (
              <Button
                variant="outlined"
                sx={{
                  color: "#5F5FEF",
                  borderColor: "#E0E0E0",
                  borderRadius: "6px",
                  fontSize: { xs: "12px", sm: "14px" },
                  padding: { xs: "4px 10px", sm: "6px 15px" },
                  height: "40px",
                  width: "106px",
                }}
                onClick={() => handleOpen(row)}
              >
                Connect
              </Button>
            )}
          </Box>
        </Box>
      ))}
      <Stripeaccount open={open} onClose={handleClose} value={photo} />

      {/* Confirmation Modal for Disconnect */}
      <ConfirmationModal
        showModal={confirmatioModalState.showModal}
        submitHandler={deleteHandler}
        submitText={"Confirm Disconnect"}
        cancelText={"Cancel"}
        cancelHandler={cancelHandler}
        headerText={"Are you sure you want to disconnect your Stripe account?"}
        bodyText={
          "You will not be able to receive payments through POSTPAL after disconnecting."
        }
      />
    </Box>
  );
}
